import { useEffect, useState } from "react"
import { cn } from "@/lib/utils"

type Star = {
  id: number
  x: number
  y: number
  size: number
  duration: number
  delay: number
  opacity: number
}

type StarsBackgroundProps = {
  count?: number
  className?: string
  color?: string
  minSize?: number
  maxSize?: number
}

export function StarsBackground({
  count = 90,
  className,
  color = "var(--color-brand)",
  minSize = 0.5,
  maxSize = 2.2,
}: StarsBackgroundProps) {
  const [stars, setStars] = useState<Array<Star>>([])
  useEffect(() => {
    setStars(
      Array.from({ length: count }).map((_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        size: minSize + Math.random() * (maxSize - minSize),
        duration: 2.5 + Math.random() * 4,
        delay: Math.random() * 5,
        opacity: 0.25 + Math.random() * 0.6,
      }))
    )
  }, [count, minSize, maxSize])

  return (
    <div
      className={cn(
        "pointer-events-none absolute inset-0 overflow-hidden",
        className
      )}
      aria-hidden="true"
    >
      {stars.map((s) => (
        <span
          key={s.id}
          className="absolute rounded-full"
          style={{
            left: `${s.x}%`,
            top: `${s.y}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            backgroundColor: color,
            opacity: s.opacity,
            boxShadow: `0 0 ${s.size * 2.5}px rgb(var(--brand-rgb) / 0.33)`,
            animation: `eklo-twinkle ${s.duration}s ${s.delay}s infinite ease-in-out`,
          }}
        />
      ))}
      <style>{`
        @keyframes eklo-twinkle {
          0%, 100% { opacity: 0.2; transform: scale(0.85); }
          50% { opacity: 1; transform: scale(1.15); }
        }
      `}</style>
    </div>
  )
}
